module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_vm._v("D")]), _vm._v("Ad\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('b', [_vm._v("Dinsafer")]), _vm._v("Admin\n      ")])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "sidebar-toggle toggle-menu-icon",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [(_vm.user.icon == '') ? _c('img', {
    staticClass: "user-image",
    attrs: {
      "src": require("../../static/img/img_device_user_default.png"),
      "alt": "User Image"
    }
  }) : _c('img', {
    staticClass: "user-image",
    attrs: {
      "src": 'https://d.din.bz/' + _vm.user.icon,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.uid))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [(_vm.user.icon == '') ? _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("../../static/img/img_device_user_default.png"),
      "alt": "User Image"
    }
  }) : _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": 'https://d.din.bz/' + _vm.user.icon,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.uid))])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    on: {
      "click": _vm.toLogout
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Logout")])])])])])])])])], 1), _vm._v(" "), (_vm.user.icon == '') ? _c('sidebar', {
    attrs: {
      "display-name": _vm.user.uid,
      "picture-url": "../../static/img/img_device_user_default.png"
    }
  }) : _c('sidebar', {
    attrs: {
      "display-name": _vm.user.uid,
      "picture-url": 'https://d.din.bz/' + _vm.user.icon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [(typeof(_vm.$route.query.devicename) !== 'undefined') ? _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.query.devicename) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]) : _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.query.appname) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.query.appname))]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.query.devicename))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "self-agent-profile"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group modal-user-profile-head"
  }, [_c('div', {
    staticClass: "modal-self-profile-upload-head",
    attrs: {
      "title": "Edit"
    }
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.uploadfile($event)
      }
    }
  })]), _vm._v(" "), (_vm.currentIcon == '') ? _c('img', {
    staticClass: "modal-user-profile-img",
    attrs: {
      "src": require("../../static/img/img_device_user_default.png")
    }
  }) : _c('img', {
    staticClass: "modal-user-profile-img",
    attrs: {
      "src": 'https://d.din.bz/' + _vm.currentIcon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-profile-img"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.progress > 0),
      expression: "progress > 0"
    }],
    staticClass: "progress progress-xxs active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped",
    style: ('width: ' + _vm.progress + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.progress) + "% Complete")])])])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.user.uid))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("E-mail Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "useremail",
      "placeholder": "E-mail Address..."
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoUpdataUser
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#self-agent-profile"
    }
  }, [_vm._v("Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("My Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box modal-new-version-shell-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Original Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "useropw",
      "placeholder": "password"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "usernpw",
      "placeholder": "password"
    }
  })])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-521a128d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-521a128d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 469
// module chunks = 1